import React, { useEffect, useState } from 'react'
import Storage from '../../setting/ManageMedia/Storage'
import httpService from '../../../services/http.service'
import { IoIosArrowDown, IoIosArrowForward } from 'react-icons/io'
import { FaFileAlt, FaFolder } from 'react-icons/fa'
import { useHistory } from "react-router-dom"
import ErrorMessage from '../../common/errorMsg'
import Loader from './Loader'

const CloudStorageDashboard = () => {

  const [selectedUser, setSelectedUser] = useState()
  const [users, setUsers] = useState([])
  const [files, setFiles] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [folderStructure, setFolderStructure] = useState([])
  const [openFolderName, setOpenFolderName] = useState('')
  const history = useHistory()


  const getAllAssociatedUser = async () => {
    try {

      const { data } = await httpService.get("/property-manager/get-all-associate-users")

      setUsers(data.userData.users)
      if (data.userData.users.length > 0) {

        setSelectedUser(data.userData.users[0]._id)
      }
    } catch (error) {
      console.log(error)
      if (error.response.status === 401) {
        history.push("/")
        localStorage.clear()
      }
    } finally {
      setIsLoading(false)
    }
  }

  const getNASUserFiles = async () => {
    try {
      if (users.length > 0) {
        let { data } = await httpService.get(`/show-user-bucket-files?userID=${selectedUser}`)
        setFiles(data.files)
        organizeFilesByFolder(data.files)
      }
    }
    catch (err) {
      if (err.response.status === 401) {
        history.push("/")
        ErrorMessage(err.response.data.message)
        localStorage.clear()
      }
    }
  }

  function organizeFilesByFolder(files) {
    const structure = [];
    files?.forEach(file => {
      const path = file.name.split('/').filter(Boolean).slice(2);
      const name = path[0];
      const isFolder = path.length > 1;

      const existing = structure.find(item => item.name === name);

      if (isFolder) {
        if (existing) {
          existing.fileCount++;
          existing.size += file.size;
        } else {
          structure.push({ name, type: 'folder', size: file.size, fileCount: 1 });
        }
      } else {
        structure.push({ name, type: 'files', size: file.size });
      }
    });
    console.log(333, structure)
    setFolderStructure(structure)
  }

  const toggleFolder = (folderName) => {
    if (folderName === openFolderName)
      setOpenFolderName('')
    else
      setOpenFolderName(folderName)

  };

  const FilesRow = ({ file }) => {
    const isFolder = file?.type === 'folder';
    const isOpen = openFolderName === file.name;
    const [folderFiles, setFolderFiles] = useState([])
    useEffect(() => {
      if (isFolder) {
        const tempFolderfiles = files.filter(ele => ele.name.includes(file.name))
        setFolderFiles(tempFolderfiles.map(ele => ({ ...ele, folderName: file.name, name: ele.name.split('/').at(-1) })))
      }
    }, [])
    return <>
      <tr key={file.name} >
        <td className="">
          <div className="flex items-center gap-2" style={{ display: 'flex', alignItems: 'center', gap: '6px', paddingLeft: file.folderName ? 36 : 16 }}>
            {isFolder && (
              <span onClick={() => toggleFolder(file.name)} style={{ cursor: 'pointer' }}>
                {isOpen ? <IoIosArrowDown /> : <IoIosArrowForward />}
              </span>
            )}
            {isFolder ? <FaFolder /> : <FaFileAlt />}
            <span>{file.name}</span>
          </div>
        </td>
        <td className="">{file?.fileCount ?? '--'}</td>
        <td className="">
          {file.size / 1e6 < 1
            ? `${(file.size / 1e3).toFixed(2)} KB`
            : `${(file.size / 1e6).toFixed(2)} MB`}
        </td>
      </tr>
      {(isOpen && folderFiles.length > 0) &&
        folderFiles.map((ele, index) => <FilesRow key={index} file={ele} />)}
    </>
  }

  useEffect(() => {
    getAllAssociatedUser()
  }, [])

  console.log(selectedUser, "selected User")

  useEffect(() => {
    console.log("Hello")
    getNASUserFiles()
  }, [selectedUser])

  return (
    <>
      {isLoading ? <Loader /> : <>
        <div className='file-list-boxdiv2'>
          <div className="sorting-main">
            <div className="file-heading">
              <h3>Users Media</h3>
              <div className="file-searching">
                <select
                  className="selected"
                  value={selectedUser}
                  onChange={(e) => setSelectedUser(e.target.value)}
                >
                  <option value="" disabled selected>Select User</option>
                  {users && users.map((item) => (
                    <option key={item._id} value={item._id}>
                      {item.customerId}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
          {folderStructure.length === 0 ? <div style={{ height: "70%", fontSize: 17, width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>{users.length === 0 ? "No user was found." : "This user has not uploaded any assets."}</div> : <table className="file-list">
            <thead>
              <tr className='list-head'>
                <th>Files/Folders Name</th>
                <th>File Count</th>
                <th>Size</th>
              </tr>
            </thead>
            <tbody>
              {folderStructure && folderStructure.map((file, index) => (
                <>
                  <FilesRow key={index} file={file} />
                </>
              ))}
            </tbody>
          </table>}
        </div>
      </>}

    </>
  )
}

export default CloudStorageDashboard